import { render, staticRenderFns } from "./PPT.vue?vue&type=template&id=1111b47c&scoped=true"
import script from "./PPT.vue?vue&type=script&lang=js"
export * from "./PPT.vue?vue&type=script&lang=js"
import style0 from "./PPT.vue?vue&type=style&index=0&id=1111b47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1111b47c",
  null
  
)

export default component.exports